import React, { useState } from "react";
import contactusimg from '../assets/contactusimg.png'; // Adjust the path as necessary
import { submitContact } from './api';
import SmsConsent, { isValidUsMobile, submitSmsOptIn } from './SmsConsent';

const Contactussection = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    city: '',
    street: '',
    subject: '',
    message: ''
  });
  const [smsConsent, setSmsConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Don't accept a consent we can't act on: a number we can't text is not a
    // usable opt-in, and silently dropping it would leave the supporter
    // believing they signed up.
    if (smsConsent && !isValidUsMobile(formData.phone)) {
      setMessage('To receive text messages, please enter a valid 10-digit US mobile number.');
      setMessageType('error');
      return;
    }

    setLoading(true);
    setMessage('');
    setMessageType('');

    try {
      // Combine additional fields into the message for the simple Contact model
      const contactData = {
        name: formData.name,
        email: formData.email,
        message: `Subject: ${formData.subject}\nPhone: ${formData.phone}\nCity: ${formData.city}\nStreet: ${formData.street}\n\nMessage:\n${formData.message}`
      };
      
      await submitContact(contactData);

      // The message is delivered by this point, so a failed opt-in must not be
      // reported as a failed contact submission.
      let optInFailed = false;
      if (smsConsent) {
        const [firstName, ...rest] = formData.name.trim().split(/\s+/);
        try {
          await submitSmsOptIn({
            firstName,
            lastName: rest.join(' '),
            email: formData.email.trim(),
            phone: formData.phone
          });
        } catch (optInError) {
          optInFailed = true;
        }
      }

      if (optInFailed) {
        setMessage(
          'Your message was sent, but we could not sign you up for text updates. ' +
          'Please try again on our Get Text Updates page.'
        );
        setMessageType('error');
      } else if (smsConsent) {
        setMessage(
          "Thank you for your message! You're also signed up for text updates — " +
          'reply STOP at any time to cancel.'
        );
        setMessageType('success');
      } else {
        setMessage('Thank you for your message! We will get back to you soon.');
        setMessageType('success');
      }

      setFormData({
        name: '',
        phone: '',
        email: '',
        city: '',
        street: '',
        subject: '',
        message: ''
      });
      setSmsConsent(false);
    } catch (error) {
      setMessage('Failed to send message. Please try again.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contactussection">
      <div class="max-width">

        <div class="get-in-touch-container">
          <div class="horizontal mb-vertical gap-20" style={{ height: "100%" }}>
            <div className="full-width text-form-container">

              <h2>Get in <span style={{ color: "grey" }}>Touch</span></h2>
              <p>We love to hear from you.</p>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <input 
                    type="text" 
                    name="name"
                    placeholder="Full Name" 
                    value={formData.name}
                    onChange={handleChange}
                    required 
                  />
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Contact Number"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Directly below the phone field, unchecked by default, and
                    optional — this form's purpose is contacting the campaign. */}
                <div className="form-group">
                  <SmsConsent
                    id="contactSmsConsent"
                    checked={smsConsent}
                    onChange={setSmsConsent}
                  />
                </div>

                <div className="form-group">
                  <input 
                    type="email" 
                    name="email"
                    placeholder="Your Email" 
                    value={formData.email}
                    onChange={handleChange}
                    required 
                  />
                </div>

                <div className="form-group">
                  <input 
                    type="text" 
                    name="city"
                    placeholder="City" 
                    value={formData.city}
                    onChange={handleChange}
                    required 
                  />
                </div>

                <div className="form-group">
                  <input 
                    type="text" 
                    name="street"
                    placeholder="Street" 
                    value={formData.street}
                    onChange={handleChange}
                    required 
                  />
                </div>

                <div className="form-group">
                  <input 
                    type="text" 
                    name="subject"
                    placeholder="Subject" 
                    value={formData.subject}
                    onChange={handleChange}
                    required 
                  />
                </div>
                <div className="form-group">
                  <textarea 
                    name="message"
                    cols="30" 
                    rows="10" 
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <button type="submit" className="btn-primary-primary full-width" disabled={loading}>
                  {loading ? 'Sending...' : 'Send Message'}
                </button>
                
                {message && (
                  <div className={`message ${messageType}`} style={{
                    padding: '10px',
                    borderRadius: '5px',
                    marginTop: '10px',
                    textAlign: 'center',
                    color: 'white',
                    backgroundColor: messageType === 'success' ? '#28a745' : '#dc3545'
                  }}>
                    {message}
                  </div>
                )}
              </form>
            </div>

            <div className="full-width map-container">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3154.2557876588908!2d72.80378217550182!3d33.7231774732827!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfa3006d8b8e3b%3A0x6c75140219cc3afe!2sVesprr%20Technologies%20(PRIVATE)%20LIMITED!5e1!3m2!1sen!2s!4v1744214240536!5m2!1sen!2s" className="map" ></iframe>
            </div>

          </div>

        </div>

        <img src={contactusimg} className="contact full-width" style={{ marginTop: '70px' }} alt="asg contact" />

        <div className="news-letter-subscription">
          <div className="horizontal news-letter-container mb-vertical align-center gap-20 fulla-width">
            <div className="news-letter-text">Subscribe Newsletters</div>
            <div className="news-letter-input-container align-center horizontal  gap-10">
              <input type="email" placeholder="Your Email" required />
              <button className="btn-primary-primary">Subscribe</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Contactussection;